import { render, staticRenderFns } from "./PureCard.vue?vue&type=template&id=04ac85f0&"
import script from "./PureCard.vue?vue&type=script&lang=js&"
export * from "./PureCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports